import styled from "styled-components";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  & + & {
    margin-top: 32px;
  }
`;

export const SectionTitle = styled(Text).attrs({
  as: "h3",
  typography: "h5",
})`
  margin: 0;
`;

export const SectionDescription = styled(Text).attrs({
  as: "p",
  typography: "b2",
  color: ColorV2.Blue4,
})`
  margin: 0;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
